import { relatoriosAtendimento } from '@/services/atendimentoestudante/relatorios-catalogo';
import { eTipoPermissao } from '@/enums/ePermissoes';
import { resolverPermissaoTela } from '@/composables/usePermissaoTela/usePermissaoTela';
const destinosModulo: { nome: string; permissao: eTipoPermissao }[] = [
  {
    nome: 'atendimento_catalogos',
    permissao: eTipoPermissao.ATENDIMENTO_CADASTROS_NOVO_MENU_3200100100,
  },
  {
    nome: 'atendimento_analises',
    permissao: eTipoPermissao.ATENDIMENTO_ANALISES_NOVO_MENU_3200100200,
  },
  {
    nome: 'atendimento_servicos',
    permissao: eTipoPermissao.ATENDIMENTO_SERVICOS_NOVO_MENU_3200100300,
  },
  { nome: 'atendimento_agenda', permissao: eTipoPermissao.ATENDIMENTO_AGENDA_NOVO_MENU_3200100400 },
  {
    nome: 'atendimento_prontuario',
    permissao: eTipoPermissao.ATENDIMENTO_PRONTUARIO_NOVO_MENU_3200100500,
  },
  {
    nome: 'atendimento_relatorios',
    permissao: eTipoPermissao.ATENDIMENTO_RELATORIOS_NOVO_MENU_3200100600,
  },
  {
    nome: 'atendimento_avisos_secretaria',
    permissao: eTipoPermissao.ATENDIMENTO_AVISOS_SECRETARIA_NOVO_MENU_3200100710,
  },
  {
    nome: 'atendimento_avisos_apoio',
    permissao: eTipoPermissao.ATENDIMENTO_AVISOS_APOIO_NOVO_MENU_3200100720,
  },
  {
    nome: 'atendimento_configuracao',
    permissao: eTipoPermissao.ATENDIMENTO_CONFIGURACAO_NOVO_MENU_3200100800,
  },
];

destinosModulo.push(
  ...relatoriosAtendimento.map((r) => ({
    nome: `atendimento_relatorio_${r.id.toLowerCase()}`,
    permissao: r.permissao,
  })),
);

export default [
  ...relatoriosAtendimento.map((relatorio) => ({
    path: `/atendimentoestudante/relatorios/${relatorio.id.toLowerCase()}`,
    name: `atendimento_relatorio_${relatorio.id.toLowerCase()}`,
    description: relatorio.texto,
    component: () => import('@/views/atendimentoestudante/relatorios/Index.vue'),
    props: { tipoInicial: relatorio.id, relatorioFixo: true },
    parent: 'atendimento_relatorios',
    meta: {
      permissions: [
        relatorio.permissao,
        eTipoPermissao.ATENDIMENTO_RELATORIOS_NOVO_MENU_3200100600,
      ],
    },
    goesToMenu: true,
  })),
  {
    path: '/atendimentoestudante/relatorios',
    name: 'atendimento_relatorios',
    description: 'Relatórios de atendimento',
    component: () => import('@/views/atendimentoestudante/relatorios/Index.vue'),
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_RELATORIOS_NOVO_MENU_3200100600] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante/configuracao',
    name: 'atendimento_configuracao',
    description: 'Configuração e alertas de atendimento',
    component: () => import('@/views/atendimentoestudante/monitoramento/Index.vue'),
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_CONFIGURACAO_NOVO_MENU_3200100800] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante/avisos-secretaria',
    name: 'atendimento_avisos_secretaria',
    description: 'Avisos à secretaria da escola',
    component: () => import('@/views/atendimentoestudante/monitoramento/Index.vue'),
    props: { perfil: 'Secretario' },
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_AVISOS_SECRETARIA_NOVO_MENU_3200100710] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante/avisos-apoio',
    name: 'atendimento_avisos_apoio',
    description: 'Avisos à equipe de apoio',
    component: () => import('@/views/atendimentoestudante/monitoramento/Index.vue'),
    props: { perfil: 'Apoio' },
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_AVISOS_APOIO_NOVO_MENU_3200100720] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante/agenda',
    name: 'atendimento_agenda',
    description: 'Minha agenda de atendimentos',
    component: () => import('@/views/atendimentoestudante/agenda/Index.vue'),
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_AGENDA_NOVO_MENU_3200100400] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante/prontuario',
    name: 'atendimento_prontuario',
    description: 'Meus prontuários',
    component: () => import('@/views/atendimentoestudante/prontuario/Index.vue'),
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_PRONTUARIO_NOVO_MENU_3200100500] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante/servicos',
    name: 'atendimento_servicos',
    description: 'Serviços de atendimento',
    component: () => import('@/views/atendimentoestudante/servicos/Index.vue'),
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_SERVICOS_NOVO_MENU_3200100300] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante',
    name: 'AtendimentoEstudante',
    description: 'Atendimento ao Estudante',
    redirect: () => ({
      name:
        destinosModulo.find((d) => resolverPermissaoTela([d.permissao]).visualizar)?.nome ??
        'atendimento_analises',
    }),
    goesToMenu: true,
    meta: {
      permissions: destinosModulo.map((d) => d.permissao),
    },
  },
  {
    path: '/atendimentoestudante/catalogos',
    name: 'atendimento_catalogos',
    description: 'Atendimento ao Estudante — Cadastros',
    component: () => import('@/views/atendimentoestudante/catalogos/Index.vue'),
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_CADASTROS_NOVO_MENU_3200100100] },
    goesToMenu: true,
  },
  {
    path: '/atendimentoestudante/analises',
    name: 'atendimento_analises',
    description: 'Atendimento ao Estudante — Análises',
    component: () => import('@/views/atendimentoestudante/analises/Index.vue'),
    meta: { permissions: [eTipoPermissao.ATENDIMENTO_ANALISES_NOVO_MENU_3200100200] },
    goesToMenu: true,
  },
];
